import gql from 'graphql-tag';

const UPDATE_OTA_COMPATIBLE_DEVICE = gql`
  mutation Mutation($deviceSerialNo: String!, $flag: Boolean!) {
    markOTACompatibleDevice(deviceSerialNo: $deviceSerialNo, flag: $flag) {
      code
    }
  }
`;

export default UPDATE_OTA_COMPATIBLE_DEVICE;
